document.addEventListener('DOMContentLoaded', () => {
  let loading = false
  let queryZero = true
  let flkty

  if (!customElements.get('free-gift-progress')) {
    customElements.define('free-gift-progress', class FreeGiftProgress extends HTMLElement {
      constructor() {
        super()
        this.progressSettings = JSON.parse(this.querySelector('#free-gift-tier-amount').innerHTML)

        this.cartTotalPrice = this.progressSettings.cartTotalPrice + this.progressSettings.thresholdAmount

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.querySelector('#free-gift-multiple-bar')) {
          this.onUpdateMultipleBar()
        } else {
          this.onUpdateOneBar()
        }
      }

      progressSettings = {}
      cartItems = {}
      cartTotalPrice = 0

      onUpdateMultipleBar() {
        const rate = 1
        const currency = this.progressSettings.currency

        let oneText = ''
        let oneWidth = ''

        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          const oneAmount = this.progressSettings.tierOneAmount * rate

          if (this.querySelector('[for="tier-one-currency"]'))
            this.querySelector('[for="tier-one-currency"]').innerHTML = currency + (oneAmount / 100).toFixed(2)

          oneText = this.progressSettings.tierOneText.replace('$money', 'SPEND ' + currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          oneWidth = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * 100
        } else {
          oneText = this.progressSettings.tierOneFullfilText
          oneWidth = 100
        }
        if (this.querySelector('#tier-one-bar'))
          this.querySelector('#tier-one-bar').style.width = `${oneWidth}%`

        if (this.querySelector('#tier-one-fullfil-text') && oneWidth === 100) {
          this.querySelector('#tier-one-fullfil-text').innerHTML = oneText
        } else if (this.querySelector('#tier-one-text')) {
          this.querySelector('#tier-one-text').innerHTML = oneText
        }

        let twoText = ''
        let twoWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          const twoAmount = this.progressSettings.tierTwoAmount * rate

          if (this.querySelector('[for="tier-two-currency"]'))
            this.querySelector('[for="tier-two-currency"]').innerHTML = currency + (twoAmount / 100).toFixed(2)

          twoText = this.progressSettings.tierTwoText.replace('$money', currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2))
          twoWidth = this.cartTotalPrice / (this.progressSettings.tierTwoAmount * rate) * 100
        } else {
          twoText = this.progressSettings.tierTwoFullfilText
          twoWidth = 100
        }

        if (this.querySelector('#tier-two-bar'))
          this.querySelector('#tier-two-bar').style.width = `${twoWidth}%`

        if (this.querySelector('#tier-two-fullfil-text') && twoWidth === 100) {
          this.querySelector('#tier-two-fullfil-text').innerHTML = twoText
        } else if (this.querySelector('#tier-two-text')) {
          this.querySelector('#tier-two-text').innerHTML = twoText
        }

        let threeText = ''
        let threeWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          const threeAmount = this.progressSettings.tierThreeAmount * rate

          if (this.querySelector('[for="tier-three-currency"]'))
            this.querySelector('[for="tier-three-currency"]').innerHTML = currency + (threeAmount / 100).toFixed(2)

          threeText = this.progressSettings.tierThreeText.replace('$money', currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2))
          threeWidth = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        } else {
          threeText = this.progressSettings.tierThreeFullfilText
          threeWidth = 100
        }
        if (this.querySelector('#tier-three-bar'))
          this.querySelector('#tier-three-bar').style.width = `${threeWidth}%`

        if (this.querySelector('#tier-three-fullfil-text') && threeWidth === 100) {
          this.querySelector('#tier-three-fullfil-text').innerHTML = threeText
        } else if (this.querySelector('#tier-three-text')) {
          this.querySelector('#tier-three-text').innerHTML = threeText
        }
      }

      isFirstInCart() {
        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (firstProduct) {
          let freeProductData = JSON.parse(firstProduct.querySelector('#free-products').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const product of freeProductData) {
              for (const variant of product.variants)
                if (item.variant_id === variant.id && item.final_line_price === 0) {
                  return true
                }
            }
          }
        }

        return false
      }

      onUpdateOneBar() {
        const sortedTiers = this.sortTiers();

        let text = ''
        const rate = 1
        const currency = this.progressSettings.currency

        let maxAmount = sortedTiers.length > 0 ? sortedTiers[sortedTiers.length - 1].amount : 0;

        let width = this.cartTotalPrice / (maxAmount * rate) * 100

        const oneLeft = (this.progressSettings.tierOneAmount / maxAmount) * 100
        const twoLeft = (this.progressSettings.tierTwoAmount / maxAmount) * 100
        const threeLeft = (this.progressSettings.tierThreeAmount / maxAmount) * 100

        if (this.querySelector('[data-tier="one"]'))
          this.querySelector('[data-tier="one"]').style.left = `${oneLeft}%`

        if (this.querySelector('#one-bar-tier-one-title')) {
          if (this.progressSettings.showTierOne === false) {
            this.querySelector('#one-bar-tier-one-title').style.left = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
          } else if (this.progressSettings.showTierThree === false) {
            this.querySelector('#one-bar-tier-one-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
          } else {
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.position = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`

            if (this.querySelector('#one-bar-tier-three-title')) {
              this.querySelector('#one-bar-tier-three-title').style.left = `unset`
              this.querySelector('#one-bar-tier-three-title').style.position = `unset`
              this.querySelector('#one-bar-tier-three-title').style.transform = `none`
            }

            if (this.querySelector('#one-bar-tier-four-title')) {
              this.querySelector('#one-bar-tier-four-title').style.left = `unset`
              this.querySelector('#one-bar-tier-four-title').style.position = `unset`
              this.querySelector('#one-bar-tier-four-title').style.transform = `none`
            }

            this.querySelector('.one-bar-text-wrapper').style.display = "flex"
            this.querySelector('.one-bar-text-wrapper').style.gap = "10px"
          }
        }

        if (this.progressSettings.showTierFour) {
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.left = `${twoLeft}%`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title').style.left = `${50}%`
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.left = `${threeLeft}%`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title').style.left = `${50}%`

          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.right = `0`
          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.transform = `translateX(0)`
        } else {
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.display = 'none'
          if (this.querySelector('#one-bar-tier-three-title')) {
            this.querySelector('#one-bar-tier-three-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-three-title').style.transform = `translateX(0)`
          }
        }

        const baseLeft = this.querySelector('.progress-bar-outer').getClientRects()[0].left

        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate && this.querySelector('#one-bar-tier-one-title') && this.progressSettings.showTierOne) {
          let tierOnePercent = 0
          if (this.progressSettings.showTierThree) {
            const tierOneLength = (this.querySelector('#one-bar-tier-one-title').getClientRects()[0].right - 5) - baseLeft
            tierOnePercent = tierOneLength / this.querySelector('.progress-bar-outer').getClientRects()[0].width
          } else {
            tierOnePercent = 1
          }

          width = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * tierOnePercent * 100

          text = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount - this.cartTotalPrice) * rate / 100).toFixed(2))
        } else if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate && this.progressSettings.showTierThree) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')

          if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate && this.querySelector('#one-bar-tier-three-title')) {

            let tierThreePercent = 0
            if (this.progressSettings.showTierFour) {
              tierThreePercent = (this.querySelector('#one-bar-tier-three-title').getClientRects()[0].right - 5) - baseLeft
            } else {
              tierThreePercent = 1
            }
            width = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * tierThreePercent * 100

            text = this.progressSettings.tierThreeText.replace('$money', currency + ((this.progressSettings.tierThreeAmount - this.cartTotalPrice) * rate / 100).toFixed(2))
          } else {
            text = this.progressSettings.tierThreeFullfilText.replace(this.isFirstInCart() ? 'Add to bag below.' : '', '')
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
        } else if (this.cartTotalPrice < this.progressSettings.tierFourAmount * rate && this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')

          text = this.progressSettings.tierFourText.replace('$money', currency + ((this.progressSettings.tierFourAmount - this.cartTotalPrice) * rate / 100).toFixed(2))

          width = this.cartTotalPrice / (this.progressSettings.tierFourAmount * rate) * 100

        } else {
          if (this.progressSettings.showTierThree && this.progressSettings.showTierFour) {
            text = !this.isFirstInCart() ? this.progressSettings.tierThreeFullfilText : this.progressSettings.tierFourFullfilText
          } else if (this.progressSettings.showTierThree) {
            text = this.progressSettings.tierFourFullfilText
          } else {
            text = this.progressSettings.tierOneFullfilText
          }
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]')) {
            this.querySelector('[data-tier="one"]').style.background = `white`
          }
          if (this.querySelector('[data-tier="two"]')) {
            this.querySelector('[data-tier="two"]').style.background = `white`
            this.querySelector('#one-bar-tier-two-title').classList.add('fullfil')
          }
          if (this.querySelector('[data-tier="three"]')) {
            this.querySelector('[data-tier="three"]').style.background = `white`
          }
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')

          this.querySelector('#one-bar-tier-four-title')?.classList.add('fullfil')

          width = 100
        }

        if (document.querySelector('#one-bar-text')) {
          document.querySelector('#one-bar-text').innerHTML = text
          this.querySelector('#one-bar-progress').style.width = `${width}%`;
        }
      }

      sortTiers() {
        const tierAmounts = [
          { tier: 'one', amount: this.progressSettings.tierOneAmount },
          { tier: 'two', amount: this.progressSettings.tierTwoAmount },
          { tier: 'three', amount: this.progressSettings.tierThreeAmount }
        ];

        if (this.progressSettings.showTierFour) {
          tierAmounts.push({ tier: 'four', amount: this.progressSettings.tierFourAmount });
        }

        tierAmounts.sort((a, b) => a.amount - b.amount);

        const textWrapper = this.querySelector('.one-bar-text-wrapper');
        if (textWrapper) {
          tierAmounts.forEach((tierInfo, index) => {
            const tierElement = this.querySelector(`#one-bar-tier-${tierInfo.tier}-title`);
            if (tierElement) {
              tierElement.style.order = index;
            }
          });
        }

        return tierAmounts;
      }
    })
  }

  if (!customElements.get('free-gift-product')) {
    customElements.define('free-gift-product', class FreeGiftProduct extends HTMLElement {
      constructor() {
        super()
        this.rate = 1;

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        this.cartTotalPrice = this.cartItems.total_price + Number(this.getAttribute('data-threshold-amount'))
        this.freeProductData = JSON.parse(this.querySelector('#free-products').innerHTML)
        this.freeProductAmount = Number(this.getAttribute('data-free-number')) * this.rate

        const json = JSON.parse(this.querySelector('#free-product-json').innerHTML)
        this.freeGiftJson = json

        if (this.freeGiftJson.show) {
          this.setText(json)

          this.querySelectorAll('select').forEach(item => item.addEventListener('change', event => this.onVarBtnSelect(event)))

          if (this.freeGiftJson.addToType === 'add-btn') {
            this.querySelectorAll('.free-gift-product-buy').forEach(item => item.addEventListener('click', (event) => this.onAddBtnClick(event)))
          }

          this.onCartUpdate()
        } else {
          document.querySelector('cart-drawer').classList.remove('is-loading')
        }
      }

      flkty = null
      rate = 0
      freeGiftJson = {}
      cartTotalPrice = 0
      cartItems = {}
      freeProductIndex = 0
      freeVariantIndex = 0
      variantToBeRemove = {}
      freeProductAmount = 0
      freeProductData = []
      hasFreeProductInCart = false

      // --- BLOCKED PRODUCT CHECK ---
      isBlockedProduct(variantId) {
        if (this.getAttribute('data-autocart') === 'true') return true

        //const blockedTitles = ['LOST IN DUSK TRAVEL SIZE 12ML EDP - GIFT', 'GIFT - THIS LOVE OF MINE TRAVEL SIZE 12ML']
        const blockedTitles = []
        return this.freeProductData.some(product =>
          blockedTitles.includes(product.title) &&
          product.variants.some(v => String(v.id) === String(variantId))
        )
      }

      setText(data) {
        const freeAmount = Number(data.freeAmount * this.rate)
        const currency = this.freeGiftJson.currency

        if (this.querySelector('#free-product-title')) {
          this.querySelector('#free-product-title').innerHTML = data.freeProductTitle.replace('$money', currency + (freeAmount / 100).toFixed(2))
        }

        if (freeAmount > this.cartItems.total_price) {
          const unlockAmount = (freeAmount - this.cartItems.total_price) / 100
          if (this.querySelector('#free-product-subtitle'))
            this.querySelector('#free-product-subtitle').innerHTML = data.freeProductSubtitle.replace('$money', currency + unlockAmount.toFixed(2))
        }
      }

      onVarBtnSelect(event) {
        if (loading) {
          return
        }

        if (this.cartTotalPrice >= this.freeProductAmount) {
          this.querySelectorAll('.free-gift-product-buy').forEach(item => item.classList.remove('disabled'));
        }
      }

      onCartUpdate() {
        const index = Number(this.getAttribute('data-index'))
        let isFirstInCart = false
        let isSecondInCart = false

        document.querySelector('cart-drawer').classList.remove('is-loading')

        if (!this.freeProductData) {
          return
        }

        let titleText = ''

        const rate = 1;
        const currency = this.freeGiftJson.currency

        this.querySelectorAll('.free-gift-product-wrpper-inner').forEach((item) => {
          this.freeProductData.forEach((subItem, subIndex) => {
            const titleTemplate = index === 0 ? this.freeGiftJson.tierThreeTitle : this.freeGiftJson.tierFourTitle
            const freeAmount = index === 0 ? this.freeGiftJson.freeAmount : this.freeGiftJson.secondGiftAmount

            if (this.cartTotalPrice < freeAmount) {
              item.querySelector('.free-gift-product-wrapper-product-info .product-desc').innerHTML =
                titleTemplate
                  .replace('$price', `${currency}${Number((subItem.variants[0].price * rate / 100).toFixed(2))}`)
                  .replace('$moneyMore', `${currency}${Number((((freeAmount - this.cartTotalPrice) / 100) * rate).toFixed(2))}`)
                  .replace('$subtotal', `${currency}${Number((this.freeProductAmount / 100).toFixed(2))}`)
                  .replace('$title', subItem.title)
            } else {
              const title = index === 0 ? this.freeGiftJson.tierThreeFullfilText : this.freeGiftJson.tierFourFullfilText
              item.querySelector('.free-gift-product-wrapper-product-info .product-desc').innerHTML = title.replace('$title', subItem.title)
            }
          })
        })

        console.log('-----------', index === 0, this.freeGiftJson.autoRemoveFirst, this.cartItems.total_price, this.freeGiftJson.secondGiftAmount)
        if (index === 0 && this.freeGiftJson.autoRemoveFirst && this.cartItems.total_price >= this.freeGiftJson.secondGiftAmount) {
          return
        }

        const secondProduct = document.querySelectorAll('free-gift-product')[1]
        if (index === 0 && secondProduct) {
          let freeProductData = []
          secondProduct.querySelectorAll('#free-product-variants').forEach(item => {
            freeProductData = freeProductData.concat(JSON.parse(item.innerHTML))
          })

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isSecondInCart = true;
                break
              }
            }
          }

          if (isSecondInCart) {
            document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
            return
          }
        }

        for (let i = 0; i < this.cartItems.items.length; i++) {
          const item = this.cartItems.items[i]
          for (const product of this.freeProductData) {
            for (const variant of product.variants) {
              if (item.variant_id === variant.id) {
                if (item.final_line_price === 0) {
                  this.hasFreeProductInCart = true;
                  this.freeProductIndex = i + 1
                  break
                } else {
                  CartJS.removeItem(i + 1)
                  return
                }
              }
            }
          }
        }

        if (index === 1 && this.hasFreeProductInCart && !this.freeGiftJson.autoRemoveFirst) {
          return
        }

        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (index === 1 && firstProduct) {
          let freeProductData = []
          firstProduct.querySelectorAll('#free-product-variants').forEach(item => {
            freeProductData = freeProductData.concat(JSON.parse(item.innerHTML))
          })

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isFirstInCart = true;
                break
              }
            }
          }

          if (isFirstInCart && document.querySelectorAll('.tier-four')) {
            const tierFourElements = document.querySelectorAll('.tier-four');

            tierFourElements.forEach(function (element) {
              element.style.display = "flex";
            });
          }
        }


        if (this.cartTotalPrice >= this.freeProductAmount) {
          if (!this.hasFreeProductInCart) {
            if (this.freeProductData.length === 1 && this.freeGiftJson.addType === 'auto') {
              // --- BLOCKED PRODUCT CHECK: auto-add single variant ---
              if (!this.isBlockedProduct(this.freeProductData[0].id)) {
                loading = true
                CartJS.addItem(this.freeProductData[0].id)
              }
            } else {
              if (index === 0) {
                this.style.display = 'block'
              } else if (isFirstInCart || this.freeGiftJson.autoRemoveFirst) {
                this.style.display = 'block'
              }
              if (this.freeGiftJson.variantType !== 'select') {
                this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.classList.remove('disabled'))
              } else {
                this.querySelectorAll('.free-gift-select').forEach(item => item.classList.remove('disabled'))
              }
              if (this.freeGiftJson.addToType == 'add-btn') {
                this.querySelectorAll('#free-product-btn').forEach(item => {
                  // --- BLOCKED PRODUCT CHECK: auto-click add button ---
                  const btnVariantId = item.getAttribute('data-var-id')
                  if (!btnVariantId || !this.isBlockedProduct(btnVariantId)) {
                    item.classList.remove('disabled')
                    item.click()
                  }
                })
              }
            }

          } else {
            this.style.display = 'none'
            if (index === 0 && isFirstInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
            else if (index === 1 && this.hasFreeProductInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
          }
        } else if (this.hasFreeProductInCart && this.freeProductAmount > this.cartTotalPrice) {
          if (index === 0) {
            this.style.display = 'block'
          } else if (isFirstInCart) {
            this.style.display = 'block';
          }
        } else {
          if (index === 0) {
            this.style.display = 'block'
          } else if (isFirstInCart) {
            this.style.display = 'block'
          }
        }
      }

      onAddBtnClick(event) {
        if (event.target.closest('#free-product-btn').classList.contains('free-gift-loading') || event.target.closest('#free-product-btn').classList.contains('disabled')) {
          return
        }

        let id = ''
        if (this.freeGiftJson.variantType === 'select' && this.querySelector('select')) {
          id = this.querySelector('select').value
        } else if (this.querySelectorAll('.free-gift-varitant-btn').length) {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
            if (item.classList.contains('selected')) {
              id = item.getAttribute('data-var-id')
            }
          })
        } else {
          id = event.target.closest('#free-product-btn').getAttribute('data-var-id')
        }

        // --- BLOCKED PRODUCT CHECK: add button click ---
        const resolvedId = id || event.target.getAttribute('data-var-id')
        if (this.isBlockedProduct(resolvedId)) {
          return
        }

        event.target.closest('#free-product-btn').classList.add('free-gift-loading')

        loading = true
        if (id) {
          CartJS.addItem(id)
        } else {
          CartJS.addItem(event.target.getAttribute('data-var-id'))
        }
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
          item.classList.remove('selected')
        })
        this.querySelector('.free-gift-product-buy')?.classList.remove('disabled')

        event.target.classList.add('selected')

        if (this.freeGiftJson.addToType !== 'add-btn') {
          const varId = event.target.getAttribute('data-var-id')
          // --- BLOCKED PRODUCT CHECK: variant button click ---
          if (this.isBlockedProduct(varId)) {
            return
          }
          loading = true
          CartJS.addItem(varId)
          event.target.closest('.free-gift-varitant-btn').classList.add('free-gift-loading')
        }
      }
    })
  }

  if (!customElements.get('additional-products')) {
    customElements.define('additional-products', class AdditionalProducts extends HTMLElement {
      constructor() {
        super()

        this.freeGiftJson = JSON.parse(this.querySelector('#additional-product-json').innerHTML)

        if (this.freeGiftJson.variantType === 'btn')
          this.querySelectorAll('.additional-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else {
          this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', (event) => {
            this.onVarBtnSelect(event)
          }))
        }

        if (this.querySelector('.add-btn')) {
          this.querySelectorAll('.add-btn').forEach(item => item.addEventListener('click', event => {
            let id = ''
            if (event.target.classList.contains('add-btn')) {
              event.target.classList.add('free-gift-loading')
              id = event.target.getAttribute('data-var-id')
            } else {
              event.target.parentNode.classList.add('free-gift-loading')
              id = event.target.parentNode.getAttribute('data-var-id')
            }

            loading = true
            CartJS.addItem(id)
          }))
        }

        this.onCartUpdate()
        document.querySelectorAll('.main-carousel').forEach(item => {
          flkty = new Flickity(item, {
            cellAlign: 'left',
            prevNextButtons: false,
            contain: true,
            pageDots: false
          });
          flkty.resize()

          setTimeout(() => {
            item.style.visibility = 'visible'
          }, 50)
        })
      }

      cartItems = {}
      freeGiftJson = {}

      onCartUpdate() {
        this.cartItems = JSON.parse(this.querySelector('#additional-cart-json').innerHTML)
        let count = 0
        this.querySelectorAll('.additional-product-card').forEach(card => {
          const id = Number(card.getAttribute('data-product-id'))
          if (!this.cartItems.items.find(item => item.product_id === id) && count < this.freeGiftJson.number) {
            card.style.display = 'flex'
            count += 1
          } else {
            card.style.display = 'none'
            card.parentNode.removeChild(card)
          }
        })
        if (count === 0) {
          this.style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.additional-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
      constructor() {
        super()

        this.variantType = this.getAttribute('data-variant-type')
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.variantType === 'btn')
          this.querySelectorAll('.upsell-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else
          this.querySelector('.free-gift-select select')?.addEventListener('change', (event) => this.onVarBtnSelect(event))


        this.querySelector('.add-btn')?.addEventListener('click', event => {
          let id = ''
          if (event.target.classList.contains('add-btn')) {
            event.target.classList.add('free-gift-loading')
            id = event.target.getAttribute('data-var-id')
          } else {
            event.target.parentNode.classList.add('free-gift-loading')
            id = event.target.parentNode.getAttribute('data-var-id')
          }

          loading = true
          CartJS.addItem(id)
        })

        this.querySelector('.upsell-item-close')?.addEventListener('click', () => {
          this.style.display = 'none'
        })

        this.onCartUpdate()
      }

      cartItems = {}
      addToType = ''
      variantType = ''

      onCartUpdate() {
        if (!this.cartItems.items.find(item => item.product_id === Number(this.getAttribute('data-product-id'))) && !localStorage.getItem(`upsell-hide-${this.getAttribute('data-product-id')}-${this.getAttribute('data-cart-id')}`)) {
          this.querySelector('.product-card').style.display = 'flex'
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
          this.querySelector('.product-card').style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.upsell-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  let completeTimeout = null
  let noRefresh = false

  $(document).on('cart.requestComplete', (event, cart) => {
    if (completeTimeout || window.displayUpgrade) {
      return
    }
    if (window.noCartRefresh) {
      window.noCartRefresh = false
      noRefresh = true
    }

    completeTimeout = setTimeout(() => {
      let section_id = ''
      document.querySelectorAll('.shopify-section-group-header-group').forEach(item => {
        if (item.getAttribute('id').includes('cart-drawer')) {
          section_id = item.getAttribute('id').replace('shopify-section-', '')
        }
      })
      let pathname = location.pathname.split('/')[1]
      if (pathname) {
        pathname = '/' + pathname
      }

      fetch(`${pathname}/cart?section_id=` + section_id)
        .then((response) => response.text())
        .then((response) => {
          console.log(document.querySelector('#addToCart'))
          document.querySelector('#cart-drawer .drawer__inner').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML
          document.querySelector('#cart-drawer').classList.remove('is-loading')
          document.querySelector('#addToCart')?.classList.remove('free-gift-loading')

          if (!document.querySelector('#cart-drawer').classList.contains('is-drawer-open')) {
            toggleCart()
          } else {
            document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
              item.classList.toggle('is-animated')
            }, 50)
          }
          document.querySelector('checkout-btn')?.classList.remove('free-gift-loading')
          document.querySelector('#addToCart')?.classList.remove('free-gift-loading')
        })

      fetch(`${pathname}/cart.js`)
        .then((response) => response.json())
        .then((response) => {
          document.querySelectorAll('cart-counter')
            .forEach(item => {
              let count = response.item_count
              const protectionId = Number(item.getAttribute('data-order-protection-id'))

              for (const item of response.items) {
                if (item.product_id === protectionId) {
                  count--
                }
              }
              item.updateCount(count)
            })
        })
      completeTimeout = null
    }, 100)
  })
})